import React from 'react';
import dayjs from 'dayjs';
import { Row, Col } from 'antd';
import { formatAmount, formatDate, formatDateSlash } from '../Utils/Common';

// Render the same complete SOA for individual and filtered batch printing.
const BillingStatement = ({ billing }) => {
    const currentDate = dayjs().format('YYYY-MM-DD');
    const billingData = {
        ...billing,
        member_name: (billing.member_name || '').toUpperCase(),
        grand_total: formatAmount(billing.grand_total) || '0.00',
        current_account: formatAmount(billing.current_account) || '0.00',
        overdue_account: formatAmount(billing.overdue_account) || '0.00',
        billing_date: formatDateSlash(billing.billing_date) || '',
        date_after_45_days: formatDate(billing.date_after_45_days) || '',
    };

    return (
        <div className="soa-statement">
            <Row className='my-4 responsive-tab-inline'>
                <Col span={24}>
                    <Row>
                        <Col span={24} className='view-header' align="center">
                            ALTA VISTA GOLF & COUNTRY CLUB
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className='view-header' align="center">
                            Aznar Road, Pardo Cebu City
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className='view-header' align="center">
                            Tel. (032)3169979 / 09173015039 / (032)2635537 or (032)263-5533 to 35
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='mb-4 responsive-tab-inline'>
                <Col span={24}>
                    <Row>
                        <Col span={14} className='view-header' align="right">
                            STATEMENT OF ACCOUNT
                        </Col>
                        <Col span={10} className='view-header' align="right">
                            Page No. 1
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className='view-header' align="center">
                            As of {billingData.billing_date}
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='mb-5 responsive-tab-inline'>
                <Col span={24}>
                    <Row>
                        <Col span={1}>
                            <Row>
                                <Col span={24} className='view-header'>
                                    To :
                                </Col>
                            </Row>
                        </Col>
                        <Col span={10}>
                            <Row>
                                <Col span={24} className='view-header'>
                                    {billingData.member_name}
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='view-header'>
                                    {billingData.address_1}
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='view-header'>
                                    {billingData.address_2}
                                </Col>
                            </Row>
                        </Col>
                        <Col span={7}>
                            <Row>
                                <Col span={24} className='view-header center'>
                                    ({billingData.member_no})
                                </Col>
                            </Row>
                        </Col>
                        <Col span={6}>
                            <Row>
                                <Col span={24} className='view-header'>
                                    Cust ID : {billingData.ar_cust_id}
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='view-header'>
                                    SA # : {billingData.id}
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='view-header'>
                                    Fax # : {billingData.fax}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='responsive-tab-inline'>
                <Col span={4} className='view-header'>
                    Trx ID
                </Col>
                <Col span={4} className='view-header'>
                    Doc Date
                </Col>
                <Col span={4} className='view-header'>
                    Reference Doc#
                </Col>
                <Col span={6} className='view-header'>
                    Particulars
                </Col>
                <Col span={6} className='view-header center'>
                    Amount
                </Col>
            </Row>
            <Row className='responsive-tab-inline'>
                <Col span={24} className='view-header'>
                    =====================================================================================================================
                </Col>
            </Row>
            <Row className='responsive-tab-inline'>
                {billingData.billing_items?.length ? (
                    billingData.billing_items.map((billingItem) => (
                        <React.Fragment key={billingItem.id}>
                            <Col span={4} className='view-header'>{billingItem.id}</Col>
                            <Col span={4} className='view-header'>{billingItem.date}</Col>
                            <Col span={4} className='view-header'>{billingItem.reference_no}</Col>
                            <Col span={6} className='view-header'>{billingItem.particulars}</Col>
                            <Col span={6}>
                                <Row>
                                    <Col span={12} className='view-header center'>-{billingItem.balance}</Col>
                                    <Col span={12} className='view-header center'>{billingItem.amount}</Col>
                                </Row>
                            </Col>
                        </React.Fragment>
                    ))
                ) : (
                    <Col span={24} className='view-header center'>No Data Found!</Col>
                )}
            </Row>
            <Row className='my-5 responsive-tab-inline'>
                <Col span={24} className='view-header center'>
                    *** Nothing Follows ***
                </Col>
            </Row>
            <Row className='mb-4 responsive-tab-inline'>
                <Col span={24}>
                    <Row>
                        <Col span={24} className='view-header'>
                            Important Reminders :
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className='ps-3 view-header'>
                            Please pay the above account on or before {billingData.date_after_45_days} . Accounts unpaid after {billingData.date_after_45_days}  shall be classified as PAST DUE ACCOUNT and is subject to a Penalty of 3% monthly, or a fraction thereof. PAST DUE ACCOUNTS shall be re-classified as DELINQUENT ACCOUNT after 45 days.
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='responsive-tab-inline'>
                <Col span={24} className='view-header'>
                    ========================================================================================================================
                </Col>
            </Row>
            <Row className='responsive-tab-inline'>
                <Col span={18} className='view-header' align="right">
                    Total
                </Col>
                <Col span={6} className='view-header pe-4' align="right">
                    {billingData.grand_total}
                </Col>
            </Row>
            <Row className='responsive-tab-inline'>
                <Col span={24} className='view-header'>
                    ========================================================================================================================
                </Col>
            </Row>
            <Row className='responsive-tab-inline mb-4 footer-side'>
                <Col span={24}>
                    <Row>
                        <Col span={5} className='view-header'>
                            Terms of Payment :
                        </Col>
                        <Col span={11} className='view-header' align="right">
                            Overdue Accounts - Payable Immediately
                        </Col>
                        <Col span={2} className='view-header' align="right">
                            {'> >'}
                        </Col>
                        <Col span={6} className='view-header' align="right">
                            {billingData.overdue_account}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={5}>

                        </Col>
                        <Col span={11} className='view-header' align="right">
                            Current Accounts - Advance Payment
                        </Col>
                        <Col span={2} className='view-header' align="right">
                            {'> >'}
                        </Col>
                        <Col span={6} className='view-header' align="right">
                            {billingData.current_account}
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='responsive-tab-inline mb-2 footer-side'>
                <Col span={24}>
                    <Row>
                        <Col span={24} className='view-header center mb-4'>
                            You may also pay this bill through any BPI Branch:
                        </Col>
                    </Row>
                    <Row>
                        <Col span={5} className='view-header'>
                            Account Name
                        </Col>
                        <Col span={4} className='view-header center'>
                            :
                        </Col>
                        <Col span={15} className='view-header'>
                            Alta Vista Golf & Country Club
                        </Col>
                    </Row>
                    <Row>
                        <Col span={5} className='view-header'>
                            Current Account Name
                        </Col>
                        <Col span={4} className='view-header center'>
                            :
                        </Col>
                        <Col span={15} className='view-header'>
                            BPI (1301 - 0320 - 44)     /     BDO (0106 - 6002 - 8085)
                        </Col>
                    </Row>
                    <Row>
                        <Col span={5} className='view-header'>
                            Reference Number
                        </Col>
                        <Col span={4} className='view-header center'>
                            :
                        </Col>
                        <Col span={15} className='view-header'>
                            104450
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='responsive-tab-inline mb-4 footer-side'>
                <Col span={24}>
                    <Row>
                        <Col span={24} className='view-header'>
                            For online payment, send proof of payment transaction to:
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className='view-header'>
                            Email: creditandcollection@altavistagolfcebu.com
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className='view-header'>
                            Viber: 09432804882
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='responsive-tab-inline footer-side'>
                <Col span={24} className='ps-3'>
                    <Row>
                        <Col span={24} className='view-header'>
                            PLEASE DISREGARD THE STATEMENT OF ACCOUNT IF PAYMENT HAS ALREADY BEEN MADE
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className='view-header'>
                            This is a computer-generated form and if issued without any alteration, this does not require a signature. ANY PAYMENT(S) RECEIVED AFTER STATEMENT DATE ({billingData.billing_date}) ARE NOT YET INCLUDED HEREIN
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='responsive-tab-inline mb-5 mt-2'>
                <Col span={24} className='view-header' align="right">
                    Date Printed : {formatDateSlash(currentDate)}
                </Col>
            </Row>
        </div>
    );
};

export default BillingStatement;
